namespace app.upgraded {
    "use strict";

    /** @ngInject **/
    function config($stateProvider: ng.ui.IStateProvider, msNavigationServiceProvider: any) {
        $stateProvider.state("app.upgraded", {
            url : "/upgraded/{url:any}",
            parent : "app.autenticado"
        });
    }

    /** @ngInject */
    function run(upgradedService: UpgradedService) {
        upgradedService.loadUpgradedMenuItems();
    }

    angular
        .module("app.upgraded", ["app.support"])
        .config(config)
        .run(run);
}